/* eslint-disable @typescript-eslint/no-explicit-any */
import { useHeaderContext } from '@/sinister/header/contexts/HeaderContext'
import { trackEvent } from '@mercadoni/sinister/dist/cjs/monitors/services'
import { FC } from 'react'
import styled, { css } from 'styled-components'
import Link from '../../atomic/Link'
import Text from './Text'

const baseStyles = css`
  display: flex;
  padding: 20px;
  font-weight: var(--typography-weight-normal);
  color: #616161 /* character/secondary */;
`

const StyledPageLink = styled(Link)`
  ${baseStyles}
`

interface PageLinkProps {
  Wrapper?: any
  path: string
  external?: boolean
  target?: string
  text: string
  className?: string
  onCloseDrawer?: () => void
}

const PageLinkLogic: FC<PageLinkProps> = ({
  Wrapper,
  path,
  external,
  target,
  text,
  className,
  onCloseDrawer,
}) => {
  const { clientId } = useHeaderContext()

  const onClick = () => {
    trackEvent({
      eventName: 'more_about_link_clicked',
      path,
      text,
      source: 'mobile',
      clientId,
    })
    onCloseDrawer?.()
  }

  return (
    <Wrapper
      href={path}
      external={external}
      target={target}
      onClick={onClick}
      className={className}
    >
      <Text text={text} />
    </Wrapper>
  )
}

const PageLink: FC<PageLinkProps> = ({ external, ...props }) => {
  const { LinkComponent } = useHeaderContext()
  const Wrapper =
    LinkComponent && !external
      ? styled(LinkComponent)`
          ${baseStyles}
        `
      : StyledPageLink

  return <PageLinkLogic {...props} Wrapper={Wrapper} external={external} />
}
export default PageLink
